<div class="app-layout app-layout-auth">
  <div class="wrapper">
    <ng-container>
      <div class="auth" @enterLeaveHeight>
        <div class="login-form">
          <div class="logo">
            <img src="assets/images/bombardier-ssics-logo-black.svg" alt="" />
          </div>

          <form *ngIf="!oktaUrl" [formGroup]="loginFormGroup" (ngSubmit)="onLoginClick()">
            <div class="title">{{ 'login.login' | translate }}</div>
            <div class="form-group" *ngIf="loginInvalid">
              <div class="flex-row ng-invalid-comment">
                <i class="icon-attention-circled-alt fs20 mr5"></i>
                <div class="max">
                  <span class="fs16">{{ 'validation.login_failed' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>{{ 'login.username' | translate }}</label>
              <dx-text-box
                formControlName="username"
                valueChangeEvent="keyup blur change focusout"
                placeholder="{{ 'login.username' | translate }}"></dx-text-box>
              <div
                class="ng-invalid-comment"
                *ngIf="isFormControlError(loginFormGroup.get('username'), 'required')">
                {{ 'validation.usernameRequired' | translate }}
              </div>
            </div>
            <div class="submit acenter">
              <dx-button text="{{ 'login.login' | translate }}" [useSubmitBehavior]="true" />
            </div>
          </form>

          <div *ngIf="oktaUrl" class="submit acenter">
            <dx-button text="{{ 'login.login' | translate }}" (onClick)="redirectToOkta()" />
          </div>
          <div class="aright pt20">
            <dx-drop-down-button
              #ddGridButton
              [useSelectMode]="false"
              [showArrowIcon]="false"
              [deferRendering]="false"
              stylingMode="text"
              icon="icon-help-1"
              dropDownContentTemplate="contentTemplate"
              [dropDownOptions]="{ width: 230 }">
              <div *dxTemplate="let button of 'item'">
                <a
                  href="javascript:void(0)"
                  class="vam no-shadow nowrap"
                  (click)="$event.stopPropagation(); ddGridButton.opened = !ddGridButton.opened">
                  <i class="icon-help-1 text-medium"></i>
                  {{ 'general.needHelp' | translate }}
                </a>
              </div>
              <div *dxTemplate="let template of 'contentTemplate'">
                <ul class="dropdown-menu" (click)="ddGridButton.opened = false">
                  <li>
                    <a
                      href="https://ssics.blob.core.windows.net/ssicspublic/SmartServicesClientPortalTraining.mp4"
                      target="_blank"
                      (click)="ddGridButton.opened = !ddGridButton.opened; $event.stopPropagation()"
                      >{{ 'general.watchVideo' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://ssics.blob.core.windows.net/ssicspublic/SmartServicesClientPortalTraining.pdf"
                      target="_blank"
                      (click)="ddGridButton.opened = !ddGridButton.opened; $event.stopPropagation()"
                      >{{ 'general.readArticle' | translate }}</a
                    >
                  </li>
                </ul>
              </div>
            </dx-drop-down-button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
